import {Text} from 'exsportia-components'
import React, {FC, useMemo} from 'react'

import {useLocale} from '../../utils/i18n'
import {defaultSettings} from './settings'

export type SessionAvailabilitySubtitleProps = {
  availableSpots: number
  selected?: boolean
}

export const SessionAvailabilitySubtitle: FC<SessionAvailabilitySubtitleProps> = ({availableSpots, selected}) => {
  const {l} = useLocale()
  const hasAvailableSpots = useMemo(() => availableSpots > 0, [availableSpots])
  const baseSettings = useMemo(
    () => (hasAvailableSpots ? defaultSettings.availableSettings : defaultSettings.unavailableSettings),
    [hasAvailableSpots],
  )
  const settingsToUse = useMemo(
    () => (selected ? {...baseSettings, color: 'white'} : baseSettings),
    [baseSettings, selected],
  )
  const textToUse = useMemo(
    () =>
      hasAvailableSpots
        ? l('spots_available_single', {
            value: availableSpots,
            declension: ['spots_available_plural', 'spots_available_single_genitive'],
          })
        : l('full', {caseAction: 'capitalize'}),
    [hasAvailableSpots, availableSpots, l],
  )

  return (
    <Text
      text={textToUse}
      settings={settingsToUse}
    />
  )
}
